import { ColumnPublishedAt } from '~/components/SearchContentTable/columns/ColumnPublishedAt';
import { SOCIAL_PLATFORMS } from '~/constants';

import {
  ColumnComments,
  ColumnEngagements,
  ColumnImpressions,
  ColumnKeyword,
  ColumnLikes,
  ColumnReach,
  ColumnReachEngRate,
  ColumnReplies,
  ColumnShares,
  ColumnViewEngRate,
  ColumnViews,
} from './columns';
import { ColumnAverageViewPercentage } from './columns/ColumnAverageViewPercentage';

export const NOT_APPLICABLE = 'n/a';

export enum COLUMNS {
  engagements = 'engagements',
  impressions = 'impressions',
  keyword = 'keyword',
  reach = 'reach',
  reachEngRate = 'reachEngRate',
  viewEngRate = 'viewEngRate',
  views = 'views',
  publishedAt = 'publishedAt',
  likes = 'likes',
  comments = 'comments',
  shares = 'shares',
  averageViewPercentage = 'averageViewPercentage',
  replies = 'replies',
}

export const COLUMN_METHOD = {
  [COLUMNS.engagements]: ColumnEngagements,
  [COLUMNS.impressions]: ColumnImpressions,
  [COLUMNS.keyword]: ColumnKeyword,
  [COLUMNS.reach]: ColumnReach,
  [COLUMNS.reachEngRate]: ColumnReachEngRate,
  [COLUMNS.viewEngRate]: ColumnViewEngRate,
  [COLUMNS.views]: ColumnViews,
  [COLUMNS.publishedAt]: ColumnPublishedAt,
  [COLUMNS.likes]: ColumnLikes,
  [COLUMNS.comments]: ColumnComments,
  [COLUMNS.averageViewPercentage]: ColumnAverageViewPercentage,
  [COLUMNS.shares]: ColumnShares,
  [COLUMNS.replies]: ColumnReplies,
};

export const INSTAGRAM_COLUMNS = [
  COLUMNS.reach,
  COLUMNS.shares,
  COLUMNS.replies,
  COLUMNS.shares,
  COLUMNS.engagements,
  COLUMNS.reachEngRate,
  COLUMNS.views,
  COLUMNS.viewEngRate,
];

export const TIKTOK_COLUMNS = [
  COLUMNS.engagements,
  COLUMNS.views,
  COLUMNS.viewEngRate,
];

export const YOUTUBE_COLUMNS = [
  COLUMNS.views,
  COLUMNS.likes,
  COLUMNS.comments,
  COLUMNS.averageViewPercentage,
];

export const DEFAULT_COLUMNS = [
  COLUMNS.reach,
  COLUMNS.impressions,
  COLUMNS.engagements,
  COLUMNS.reachEngRate,
  COLUMNS.views,
  COLUMNS.viewEngRate,
];

export const PLATFORM_COLUMNS = {
  All: DEFAULT_COLUMNS,
  [SOCIAL_PLATFORMS.instagram]: INSTAGRAM_COLUMNS,
  [SOCIAL_PLATFORMS.tiktok]: TIKTOK_COLUMNS,
  [SOCIAL_PLATFORMS.youtube]: YOUTUBE_COLUMNS,
};
